<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="720px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>{{ modalTitle }}</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2">
          <v-card-text class="mb-0 pb-0">
            <el-overlay-loading :loading="modalloading" />
            <v-row>
              <v-col cols="12">
                <template v-if="isLocal">
                  <el-text-field label="Kodas" v-model="item.too_kodas" />
                </template>
                <template v-if="!isLocal">
                  <h4>{{ item.too_kodas }}</h4>
                </template>
              </v-col>
              <v-col cols="12" md="9" class="mb-2">
                <el-switch
                  :readonly="readonly"
                  label="Aktyvus"
                  v-model="item.too_aktyvus"
                />
              </v-col>
              <v-col cols="12" md="3" class="mb-2 text-rigth">
                <el-switch
                  v-if="isAprasymas"
                  :readonly="readonly"
                  label="HTML kodas"
                  v-model="showSource"
                />
              </v-col>
              <v-col cols="12">
                <el-textarea
                  v-if="showText"
                  label="Tekstas"
                  v-model="item.too_tekstas"
                />
                <vue-editor
                  class="mb-3"
                  v-if="showEditor"
                  :editorToolbar="customToolbar"
                  v-model="item.too_tekstas"
                ></vue-editor>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button @click.native.stop="closeModal()" :loading="modalloading">
          Atšaukti
        </el-button>
        <el-button
          v-if="!readonly"
          primary
          @click.native="saveData()"
          :loading="modalloading"
        >
          Saugoti
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { VueEditor } from 'vue2-editor'

export default {
  name: 'ModalTooltip',
  props: {
    value: Boolean,
    readonly: Boolean,
    item: Object,
    grupe: String,
  },
  components: { VueEditor },
  data() {
    return {
      loading: true,
      modalDaiktas: {},
      modalloading: true,
      showSource: false,
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  computed: {
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    isAprasymas() {
      return (
        this.grupe === 'aprasymas' ||
        (this.grupe === 'tooltip' &&
          this.item.too_kodas &&
          (this.item.too_kodas.includes('Hipoteka') ||
            this.item.too_kodas.includes('Paieška')) &&
          this.item.too_kodas.includes('Informacija')) ||
        (this.grupe === 'ntrpaslaugos' &&
          this.item.too_kodas &&
          (this.item.too_kodas.includes('Anotacija') ||
            this.item.too_kodas.includes('Santrauka') ||
            this.item.too_kodas.includes('Informacija')))
      )
    },
    showText() {
      return !this.isAprasymas || this.showSource
    },
    showEditor() {
      return this.isAprasymas && !this.showSource
    },
    modalTitle() {
      return this.isAprasymas ? 'Aprašymas' : 'Patartis (tooltip)'
    },
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    isNaujas() {
      return !(this.item.too_id > 0)
    },
    customToolbar() {
      return [
        ['bold', 'italic', 'underline', 'strike'],
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' },
        ],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ indent: '-1' }, { indent: '+1' }],
        ['link', 'clean'],
      ]
    },
  },
  created() {
    this.modalloading = false
  },
  methods: {
    saveData() {
      this.modalloading = true

      const data = {
        too_id: this.item.too_id,
        too_kodas: this.item.too_kodas,
        too_tekstas: this.item.too_tekstas,
        too_aktyvus: this.item.too_aktyvus ? true : false,
      }

      this.$axios
        .post(`admin/tooltip`, data)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.$store.dispatch('loadTooltips')
          this.closeModal()
          this.$emit('savedData', this.item)
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.modalloading = false
        })
    },
    closeModal() {
      this.showModal = false
    },
    submit() {
      if (!this.readonly && !this.isAprasymas) {
        this.saveData()
      }
    },
    cancel() {
      this.closeModal()
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
